import { SetStateAction } from 'react';
import {
  ProjectTeamMemberRole,
  SearchTeamMemberResultDto,
  TeamMemberDto,
} from 'services/api/api-client.types.ts';

export const useTeamMemberActions = (props: {
  setTeamMembers: (value: SetStateAction<TeamMemberDto[]>) => void;
}) => {
  const onChangeRole = (
    role: ProjectTeamMemberRole,
    teamMember: TeamMemberDto,
  ) => {
    props.setTeamMembers((prev) =>
      prev.map((_tm) =>
        _tm.id === teamMember.id
          ? {
              ..._tm,
              role:
                // Preserve role if it was changed to Editor from Responsible
                role === ProjectTeamMemberRole.Editor &&
                _tm.role === ProjectTeamMemberRole.Responsible
                  ? _tm.role
                  : role,
            }
          : _tm,
      ),
    );
  };

  const onChangeResponsible = (teamMember: TeamMemberDto) => {
    props.setTeamMembers((prev) =>
      prev.map((_tm) =>
        _tm.id === teamMember.id
          ? {
              ..._tm,
              role:
                _tm.role === ProjectTeamMemberRole.Responsible
                  ? ProjectTeamMemberRole.Editor
                  : ProjectTeamMemberRole.Responsible,
            }
          : _tm,
      ),
    );
  };

  const onDelete = (teamMember: TeamMemberDto) => {
    props.setTeamMembers((prev) =>
      prev.filter((_tm) => _tm.id !== teamMember.id),
    );
  };

  const onAdd = (member: SearchTeamMemberResultDto) => {
    props.setTeamMembers((prev) => [
      ...prev,
      {
        ...member,
        role: ProjectTeamMemberRole.Viewer,
      },
    ]);
  };

  return { onDelete, onChangeRole, onChangeResponsible, onAdd };
};
